"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { cn } from "@repo/design-system/utils/cn";
import { useEffect, useState } from "react";
import { useRegistry } from "~/components/registry/registry-provider";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import { ApplyButton } from "../../ui/apply-button-eon";
import { buttonVariants } from "../../ui/button-eon";
function useIsAtBottom() {
  const $ = _c(2);
  const [isAtBottom, setIsAtBottom] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const isBottom = scrollTop + windowHeight >= documentHeight - 10;
        setIsAtBottom(isBottom);
      };
      window.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isAtBottom;
}
export default function StickyApplyBar(t0) {
  const $ = _c(5);
  const {
    job
  } = t0;
  const t = useLanguage();
  const {
    ui
  } = useRegistry();
  const isAtBottom = useIsAtBottom();
  let t1;
  if ($[0] !== isAtBottom || $[1] !== job || $[2] !== t || $[3] !== ui) {
    t1 = isAtBottom ? null : <div className="fixed bottom-0 z-30 flex h-16 w-full items-center justify-center gap-4 border-gray-200 border-t bg-[#f6f6f7] px-4 shadow-lg md:hidden print:hidden">{job.data.applicationUrl && job.data.applicationUrl.length > 2 && <ApplyButton className="rounded-lg bg-primary p-2 text-white" job={job} />}{job.data.applicationUrlDirect && ui.showQuickApply && <CustomLink blank={true} className={cn(buttonVariants({
        variant: "default"
      }), "rounded-lg bg-primary p-2 text-white")} href={job.data.applicationUrlDirect}>{t.jobad_applyNow_Direct}</CustomLink>}</div>;
    $[0] = isAtBottom;
    $[1] = job;
    $[2] = t;
    $[3] = ui;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}